const advertsStrings = {
  advertsFilter: {
    searchBarPlaceholder: 'Advert ID or Campaign ID',
  },

  advertsList: {
    advertsGridNoResultsFound: 'No results matching your search criteria',
    advertsGridHeader: {
      advertsNumberGridHeader: 'Advert #',
      advertsAdvertNameGridHeader: 'Advert Name',
      advertsStatusGridHeader: 'Status',
      advertsAdvertiserNameGridHeader: 'Advertiser Name',
      advertsCampaignNameGridHeader: 'Campaign Name',
      advertsLandingValueGridHeader: 'Landing/Products',
      advertsImpressionsGridHeader: 'Impressions',
      advertsClicksGridHeader: 'Clicks',
      advertsCtrGridHeader: 'CTR',
      advertsAmountGridHeader: 'Sessions',
      advertsCpcGridHeader: 'CPC',
      advertsActionsGridHeader: 'Actions',
    },
    advertsGridEditActionBtn: 'Edit',
    advertsGridActivateActionBtn: 'Activate',
    advertsGridDeactivateActionBtn: 'Deactivate',
    actionPopupTitle(status) {
      return `Are you sure you want to mark this advert as ${status} ?`;
    },
    actionPopupYesBtn: 'Yes',
    actionPopupNoBtn: 'No',
    copiedToClipboardText: 'Copied to clipboard 🚀',
  },

  addAdvert: {
    formTitle: 'Advert Details',
    formNameFieldLabel: 'Name',
    formLandingPageFieldLabel: 'Landing Page',
    formLandingTypeFieldLabel: 'Landing Type',
    formLandingTypeFieldPlaceholder: 'Select Landing Type',
    formLandingValueFieldLabel: 'Landing Value',
    formZoneFieldLabel: 'Zone',
    formZoneFieldPlaceholder: 'Add Zone(s)',
    formImageFieldLabel: 'Image',
    formProductFieldLabel: 'Product',
    formFieldErrorText(fieldName) {
      return `${fieldName} field must have a valid value`;
    },
    formBtnText: 'Add',
  },
};

export default advertsStrings;
